
import Vue from "vue";

import { Ticket } from "../../models/tickets/ticket";
import { TicketService } from "../../services/ticket-service";
import AppChatMessages from "@/components/chat-components/ChatMessages.vue";
import AppCreatedByWinfakt from "@/components/common/CreatedByWinfakt.vue";
import { ChatMessage } from "../../utils/chat-message";

export default Vue.extend({
	data() {
		return {
			ticket: new Ticket(),
			loading: true
		};
	},
	computed: {
		messages():ChatMessage[] {
			return this.ticket.messages.map(m=>m.toChatMessage());
		}
	},
	methods: {
		async login() {
			this.$router.push(`/support/tickets/${this.ticket.id}`);
		}
	},
	async mounted() {
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();
		this.ticket= await TicketService.getTicketFromUrlToken(this.$route.params.token);
	},
	components: {
		AppChatMessages,
		AppCreatedByWinfakt
	},
});
